


























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { relationTypeQuery, relationQuery, relationTypeEdit, relationEdit, tagQuery, tagGroupQuery } from '@/api/strategyTag';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

const quarterMap = {
  Q1: '1',
  Q2: '2',
  Q3: '3',
  Q4: '4',
  年度: '5'
};

const columns = [
  {
    title: '标签1',
    dataIndex: 'tagOneName',
    key: 'tagOneName'
  },
  {
    title: '标签2',
    dataIndex: 'tagTwoName',
    key: 'tagTwoName'
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: 'description',
    width: '50%'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
];

const data = [];

@Component({})
class StrategyTagRelation extends Vue {
  relationTypeList: any[] = [];
  relationList: any[] = [];
  isActive: number = 0;
  columns: any[] = columns;
  data: any[] = data;
  relationTypeNowId: number = 0;
  relationTypeVisible: boolean = false;
  relationVisible: boolean = false;

  labelCol: object = { span: 4 };
  wrapperCol: object = { span: 14 };
  formTypeTitle: string = '';
  formType: object = {
    name: '',
    description: ''
  };
  formRelationTitle: string = '';
  formRelation: object = {
    relationId: 0,
    tagOneName: '',
    tagTwoName: '',
    tagOneId: [],
    tagTwoId: [],
    description: ''
  };
  relationNow: object = {
    relationId: 0,
    tagOneId: 0,
    tagTwoId: 0
  };

  formNowId: number = 0;

  rules: object = {
    name: [
      { required: true, message: '请输入分组名称!', trigger: 'blur' },
      { validator: this.validatePassType, trigger: 'blur' }
    ]
  };

  rules2: object = {
    relationId: [{ required: true, message: '', trigger: 'blur' }],
    tagOneId: [{ required: true, message: '请选择标签!', trigger: 'blur' }],
    tagTwoId: [{ required: true, message: '请选择标签!', trigger: 'blur' }]
  };

  optionsTagOne: any[] = [];
  optionsTagTwo: any[] = [];

  disableTagOne: any[] = [];
  disableTagTwo: any[] = [];

  mounted() {
    this.data = this.changeRelationList(this.relationList);
    this.relationTypeNowId = 0;
    this.getRelationType(1);
    // this.getTagGroup();
  }

  @Getter('token') token;

  get headers() {
    return { Authorization: this.token };
  }

  selectRelationType(id) {
    this.relationTypeNowId = id;
    this.getRelation(this.relationTypeNowId);
  }

  async editRelation(index) {
    // 新建传入-1,编辑传入的是表格行数据
    console.log('index', index);
    await this.getTagGroup();
    // this.relationVisible = true;
    // 1-新建,2-编辑
    this.formRelationTitle = index === -1 ? '选择关联标签' : '编辑关联标签';
    if (index === -1) {
      this.relationNow = {};
      this.formRelation = {
        relationId: this.relationTypeNowId,
        tagOneName: '',
        tagTwoName: '',
        tagOneId: [],
        tagTwoId: [],
        description: ''
      };
      this.formNowId = 0;
      this.disableTagOne = [];
      this.disableTagTwo = [];
    } else {
      this.formRelation = {
        relationId: this.relationTypeNowId,
        ...index
      };
      this.relationNow = {
        relationId: this.relationTypeNowId,
        tagOneId: index['tagOneId'][1],
        tagTwoId: index['tagTwoId'][1]
      };

      this.setDisableList(this.formRelation['tagOneId'], this.disableTagTwo);
      this.setDisableList(this.formRelation['tagTwoId'], this.disableTagOne);
      console.log('this.disableTagOne', this.disableTagOne);
      console.log('this.disableTagTwo', this.disableTagTwo);

      // 请求tagOne所在组的tagList
      let res1 = await tagQuery({ groupId: this.formRelation['tagOneId'][0] });
      let tmp1 = this.optionsTagOne.find(_ => _.value === this.formRelation['tagOneId'][0]);

      tmp1.children = res1.data.list.map(_ => {
        let val = { value: _.id, label: _.name };
        if (_.id !== this.formRelation['tagOneId'][1] && this.disableTagOne.indexOf(_.id) > -1) {
          val['disabled'] = true;
        }
        return val;
      });

      // 请求tagTwo所在组的tagList
      let res2 = await tagQuery({ groupId: this.formRelation['tagTwoId'][0] });
      let tmp2 = this.optionsTagTwo.find(_ => _.value === this.formRelation['tagTwoId'][0]);

      // tmp2.children = res2.data.list.map(_ => {return {value: _.id, label: _.name};});
      tmp2.children = res2.data.list.map(_ => {
        let val = { value: _.id, label: _.name };
        if (_.id !== this.formRelation['tagTwoId'][1] && this.disableTagTwo.indexOf(_.id) > -1) {
          val['disabled'] = true;
        }
        return val;
      });
      // 不加这个的话只显示一级标签
      this.optionsTagOne = [...this.optionsTagOne];
      this.optionsTagTwo = [...this.optionsTagTwo];
      console.log('ok!');
    }
    console.log('true!');
    this.relationVisible = true;
  }

  deleteRelation(text) {
    let _this = this;

    this.$confirm({
      title: '删除确认',
      content: '删除后，此标签对已经关联的项目也将被取消关联，确定删除？',
      onOk() {
        _this.relationEdit({ relationId: _this.relationTypeNowId, tagOneId: text['tagOneId'][1], tagTwoId: text['tagTwoId'][1], type: 2 });
      },
      onCancel() {}
    });
  }

  submitRelationChange(e) {
    console.log(e);
    console.log(this.relationNow);

    let tmp: any = this.$refs.ruleFormRelation;
    tmp.validate(valid => {
      if (valid) {
        if (this.relationNow['relationId']) {
          this.relationEdit({
            relationId: this.relationNow['relationId'],
            tagOneId: this.relationNow['tagOneId'],
            tagTwoId: this.relationNow['tagTwoId'],
            type: 2
          });
        }

        this.relationEdit({
          description: this.formRelation['description'],
          relationId: this.formRelation['relationId'],
          tagOneId: this.formRelation['tagOneId'][1],
          tagTwoId: this.formRelation['tagTwoId'][1],
          type: 1
        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  editRelationType(type, index) {
    // 1-新建,2-编辑
    this.formTypeTitle = type === 1 ? '新建关系' : '编辑关系';
    if (type === 1) {
      this.formType = {
        name: '',
        description: ''
      };
      this.formNowId = 0;
    } else if (type === 2) {
      this.$nextTick(() => {
        this.formType = {
          name: this.relationTypeList[index].name,
          description: this.relationTypeList[index].description,
          id: this.relationTypeList[index].id
        };
      });
      this.formNowId = this.relationTypeList[index].id;
    }
    this.relationTypeVisible = true;
  }

  deleteRelationType(index) {
    let _this = this;
    this.formType = { id: this.relationTypeList[index].id };
    console.log(this.relationTypeList, index);
    if (this.relationTypeList[index].relationNum > 0) {
      this.$confirm({
        title: '删除确认',
        content: '删除后，关系下的所有标签对将被删除，且已经关联的项目也将被取消关联，确定删除？',
        onOk() {
          _this.relationTypeEdit(2);
        },
        onCancel() {}
      });
    } else {
      _this.relationTypeEdit(2);
    }
  }

  submitTypeChange(e) {
    console.log(e);
    let tmp: any = this.$refs.ruleFormType;
    tmp.validate(valid => {
      if (valid) {
        this.relationTypeEdit(this.formTypeTitle === '新建关系' ? 3 : 1);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  cancelRelationChange() {
    let tmp: any = this.$refs.ruleFormRelation;
    setTimeout(() => {
      tmp.resetFields();
    }, 500);
  }

  cancelTypeChange() {
    //@ts-ignore
    // this.$refs.ruleFormType.resetFields();

    let tmp: any = this.$refs.ruleFormType;
    setTimeout(() => {
      tmp.resetFields();
    }, 500);
  }

  changeRelationList(list) {
    list.forEach(_ => {
      _.tagOneId = [_.tagOne.groupId, _.tagOne.id];
      _.tagTwoId = [_.tagTwo.groupId, _.tagTwo.id];
      _.tagOneName = _.tagOne.name;
      _.tagTwoName = _.tagTwo.name;
    });
    return list;
  }

  onChangeTagOne(value) {
    console.log('value1', value);
    this.setDisableList(value, this.disableTagTwo);
    // if(value.length > 0) {
    console.log('changeNow1');
  }

  onChangeTagTwo(value) {
    console.log('value2', value);
    this.setDisableList(value, this.disableTagOne);
    // if(value.length > 0) {
    console.log('changeNow2');

    this.optionsTagTwo
      .find(_ => _.value === value[0])
      .children.forEach(e => {
        if (this.disableTagTwo.indexOf(e.value) > -1) {
          e.disabled = true;
        } else {
          e.disabled = false;
        }
      });
    // }
  }

  // 级联选择onfocus时调用,用于刷新disable的标签
  refreshDisableOption(e, num) {
    console.log('focus!', e, num);

    if (num === 1) {
      this.optionsTagOne.forEach(_ => {
        if (_.children) {
          _.children.forEach(e => {
            if (this.disableTagOne.indexOf(e.value) > -1) {
              e.disabled = true;
            } else {
              e.disabled = false;
            }
          });
        }
      });
    } else {
      this.optionsTagTwo.forEach(_ => {
        if (_.children) {
          _.children.forEach(e => {
            if (this.disableTagTwo.indexOf(e.value) > -1) {
              e.disabled = true;
            } else {
              e.disabled = false;
            }
          });
        }
      });
    }
  }

  setDisableList(value, disableList) {
    if (value.length === 2 && value[1]) {
      disableList.length = 0;
      disableList.push(value[1]);
      this.data.forEach(_ => {
        // if(value.sort().toString() !== _.tagOneId.sort().toString() && ){
        if (value[1] === _.tagOneId[1]) {
          disableList.push(_.tagTwoId[1]);
          console.log('value+tagOneId', value, _.tagOneId);
        } else if (value[1] === _.tagTwoId[1]) {
          disableList.push(_.tagOneId[1]);
        }
        // }
      });
    } else {
      disableList.length = 0;
    }
    console.log('this.disableTagOne', this.disableTagOne);
    console.log('this.disableTagTwo', this.disableTagTwo);
  }

  // TODO 加disable判断
  async loadDataTagOne(selectedOptions) {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    // load options lazily
    try {
      console.log('loadDataTagOne');

      let res = await tagQuery({
        groupId: targetOption.value
      });
      if (res.code === 200) {
        targetOption.loading = false;
        targetOption.children = res.data.list.map(_ => {
          return this.disableTagOne.indexOf(_.id) > -1 ? { value: _.id, label: _.name, disabled: true } : { value: _.id, label: _.name };
        });
        this.optionsTagOne = [...this.optionsTagOne];
      }
    } catch {}
  }

  // TODO 加setDisable
  async loadDataTagTwo(selectedOptions) {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    // load options lazily
    try {
      console.log('loadDataTagTwo');

      let res = await tagQuery({
        groupId: targetOption.value
      });
      if (res.code === 200) {
        targetOption.loading = false;
        targetOption.children = res.data.list.map(_ => {
          let val = { value: _.id, label: _.name };
          if (this.disableTagTwo.indexOf(_.id) > -1) {
            val['disabled'] = true;
          }
          return val;
        });
        this.optionsTagOne = [...this.optionsTagOne];
      }
    } catch {}
  }

  async getRelationType(type) {
    // 1 - init&refresh,选中第一条
    // 2 - refresh,选中不发生改变
    // 3 - refresh,选中最后一条的
    try {
      let res = await relationTypeQuery();
      if (res.code === 200) {
        this.relationTypeList = res.data.list;

        if (type === 1) {
          if(this.relationTypeList.length > 0) {
            this.selectRelationType(this.relationTypeList[0].id);
          } else {
            this.relationList = [];
            this.data = [];
          }
        } else if (type === 2) {
          this.getRelation(this.relationTypeNowId);
        } else {
          let i = this.relationTypeList[this.relationTypeList.length - 1].id;
          this.selectRelationType(i);
        }
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getRelation(typeId) {
    try {
      let res = await relationQuery({
        relationTypeId: typeId
      });
      if (res.code === 200) {
        this.relationList = res.data.list;
        this.data = this.changeRelationList(this.relationList);
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async relationTypeEdit(type) {
    // 前端type 1/编辑 2/删除 3/新增
    // 后端接口 1.编辑/新增 2. 删除
    try {
      let res = await relationTypeEdit({
        ...this.formType,
        type
      });
      if (res.code === 200) {
        console.log('tyoe', type);

        if (type === 2) {
          this.$message.success('删除成功');
        }
        if (type === 3) {
          this.getRelationType(3);
        } else if (this.formType['id'] === this.relationTypeNowId && type === 2) {
          this.getRelationType(1);
        } else {
          this.getRelationType(2);
        }
        console.log(this.$refs);

        let tmp: any = this.$refs.ruleFormType;
        tmp.resetFields();
        this.relationTypeVisible = false;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async relationEdit(body) {
    // 1.编辑/新增 2. 删除
    try {
      let res = await relationEdit(body);
      if (res.code === 200) {
        if (body.type === 2) {
          this.$message.success('删除成功');
        }
        this.getRelationType(2);
        this.formType = {
          name: '',
          description: ''
        };
        let tmp: any = this.$refs.ruleFormRelation;
        tmp.resetFields();
        this.relationVisible = false;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getTagGroup() {
    try {
      let res = await tagGroupQuery();
      if (res.code === 200) {
        this.optionsTagOne = res.data.list.map(_ => {
          return { value: _.id, label: _.name, isLeaf: false };
        });
        this.optionsTagTwo = res.data.list.map(_ => {
          return { value: _.id, label: _.name, isLeaf: false };
        });
        return true;
      } else {
        // this.$message.error(res.msg);
        return false;
      }
    } catch (err) {
      console.log(err);
    }
  }

  validatePassType(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入关系名称!'));
    } else if (this.relationTypeList.find(_ => _.name === value && _.id !== this.formNowId)) {
      callback(new Error('当前关系已存在，请重新输入!'));
    } else {
      callback();
    }
  }
}
export default StrategyTagRelation;
